import { useContext } from 'react';
import DashboardDataContext from '../contexts/dashboardDataContext';

export const useDashboardDataContext = () => {
  const context = useContext(DashboardDataContext);
  if (!context) throw new Error('useDashboardDataContext must be used within a DashboardDataContext provider');
  return context;
};
